import SearchForm from './overview_pages/SearchForm';
import ResultsCount from './search_page/ResultsCount';
import SearchCluster from './search_page/SearchCluster';
import { scrollToTop } from '../shared';

class SearchPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hit_clusters: [],
      query: props.query_params.q || '',
      path: props.path,
      searching: false,
      count: 0,
      cluster_urls: {},
      show_legacy_categories: this.props.show_legacy_categories,
    };
    this.childRef = React.createRef();
    this.renderSearchCluster = this.renderSearchCluster.bind(this);
  }

  componentDidMount() {
    this.getResults(this.state.query, null, true);
    if (this.childRef.current) {
      this.childRef.current.focus();
    }
    window.addEventListener('popstate', this.handlePopState);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
  }

  handlePopState = () => {
    const params = new URLSearchParams(window.location.search);
    const q = params.get('q') || '';
    this.setState({ query: q }, () => {
      this.getResults(q, null, true);
    });
  };

  setSearching = () => {
    this.setState({ searching: true });
  };

  setQueryResults = (response, query) => {
    this.setState({
      searching: false,
      hit_clusters: response.hit_clusters,
      query: query,
      count: response.count,
      cluster_urls: response.cluster_urls,
    });
    this.renderContentArea();
  };

  getResults(query, page, isPopState = false) {
    let queryValue = `${query}`.trim();
    if (queryValue.length < 2) return;

    const url = new URL(window.location.href);
    url.searchParams.set('q', queryValue);
    url.searchParams.delete('page');

    if (!isPopState) {
      history.pushState(null, '', url.toString());
    }

    const { search_path } = this.props;

    this.setState({
      searching: true,
      query: queryValue,
      hit_clusters: [],
    });
    scrollToTop(this.childRef);

    $.get({
      url: search_path,
      dataType: 'json',
      data: {
        q: queryValue,
        page: page,
        path: this.state.path,
      },
      success: (data) => this.setQueryResults(data, queryValue),
      error: () => this.setState({ searching: false, hit_clusters: [] }),
    });
  }

  renderSearchCluster(clusters, name, size) {
    let current_cluster = clusters.find((x) => x.cluster === name);
    if (current_cluster !== undefined) {
      if (name === 'all') {
        return (
          <div className={clusters.length === 1 ? 'col-md-12' : 'col-md-8'}>
            <SearchCluster
              key={name}
              show_legacy_categories={this.state.show_legacy_categories}
              cluster_url={this.state.cluster_urls[name]}
              selected_cluster={current_cluster}
              filter={name}
              size={size}
              clusters={clusters}
              query={this.state.query}
              goToPage={() => this.goToPage()}
            />
          </div>
        );
      } else {
        return (
          <div
            className={
              clusters.find((x) => x.cluster === 'all') !== undefined
                ? 'col-md-4'
                : 'col-md-12'
            }
          >
            <SearchCluster
              key={name}
              show_legacy_categories={this.state.show_legacy_categories}
              cluster_url={this.state.cluster_urls[name]}
              selected_cluster={current_cluster}
              filter={name}
              size={size}
              clusters={clusters}
              query={this.state.query}
              goToPage={() => this.goToPage()}
            />
          </div>
        );
      }
    }
  }

  renderContentArea() {
    const { hit_clusters, searching, count, query } = this.state;

    if (searching && hit_clusters.length === 0) {
      return (
        <div className="text-center">
          <i className="fas fa-2x fa-spinner fa-spin"></i>
        </div>
      );
    }

    return (
      <>
        <ResultsCount count={count} query={query} />
        <div className="row search-result-area">
          {this.renderSearchCluster(hit_clusters, 'all', 10)}
          {this.renderSearchCluster(hit_clusters, 'kumpass', 3)}
          {this.renderSearchCluster(hit_clusters, 'news', 3)}
          {this.renderSearchCluster(hit_clusters, 'events', 3)}
          {this.renderSearchCluster(hit_clusters, 'career', 3)}
        </div>
      </>
    );
  }

  render() {
    return (
      <div>
        <div className="searchPage">
          <div className="filter-partial">
            <div className="filter-row">
              <div className="filter-item full search">
                <SearchForm
                  ref={this.childRef}
                  setSearching={() => this.setSearching()}
                  performSearch={(q) => this.getResults(q)}
                  defaultQuery={this.state.query}
                />
              </div>
            </div>
          </div>
          {this.renderContentArea()}
        </div>
      </div>
    );
  }
}

export default SearchPage;
